module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [(_vm.shopeeAccounts.length) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('shopee.account.label'),
      "columns": 6,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.account.identifier),
      expression: "filters.account.identifier"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters.account, "identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.shopeeAccounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.shopId
      }
    }, [_vm._v(_vm._s(((account.shopName) + " (" + (account.shopId) + ")")))])
  })], 2)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61400834","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/updateReducer/filters/marketplace/Shopee.vue
// module id = 3222
// module chunks = 0